<template>
  <van-popup
      v-model="showPopup"
      position="bottom"
      round
      closeable
      safe-area-inset-bottom
      :close-on-click-overlay="false"
      @close="onClose"
  >
    <div class="popupView">
      <div class="topView">
        <div class="headerTitle">{{ type == 'month' ? '月份选择' : type == 'week' ? '周选择' : '' }}</div>
        <div class="headerSubTitle">{{ currentYear }}</div>
      </div>
      <div class="gridList">
        <van-row>
          <van-col :span="span" v-for="(item,index) in list" :key="index">
            <div
                :class="[selectRang.length > 0 ? (item.id == selectRang[0].id ? 'startCell startRadius' : item.id == selectRang[selectRang.length-1].id ? 'endCell endRadius' : (item.id > selectRang[0].id && item.id < selectRang[selectRang.length-1].id) ? 'rangeCell' : 'normalCell') : 'normalCell']"
                @click.stop="handleSelect(item)">
              <div
                  :class="[selectRang.length > 0 ? ((item.id == selectRang[0].id || item.id == selectRang[selectRang.length-1].id) ? 'cellInfo' : (item.id > selectRang[0].id && item.id < selectRang[selectRang.length-1].id) ? 'rangeCellInfo' : 'normalCellInfo') : 'normalCellInfo']">
                {{ item.title }}
              </div>
<!--              <div-->
<!--                  v-if="selectRang.length > 0 && (item.id == selectRang[0].id || item.id == selectRang[selectRang.length-1].id)"-->
<!--                  :class="[(item.id == selectRang[0].id || item.id == selectRang[selectRang.length-1].id) ? 'cellInfo' : 'rangeCellInfo','m-t-4']">-->
<!--                {{ item.id == selectRang[0].id ? '开始' : item.id == selectRang[selectRang.length - 1].id ? '结束' : '' }}-->
<!--              </div>-->
              <div
                  v-if="selectRang.length > 1 && (item.id == selectRang[0].id && item.id == selectRang[selectRang.length-1].id)"
                  :class="[(item.id == selectRang[0].id && item.id == selectRang[selectRang.length-1].id) ? 'cellInfo' : 'rangeCellInfo','m-t-4']">
                开始/结束
              </div>
              <div
                  v-else-if="selectRang.length > 0 && item.id == selectRang[0].id"
                  :class="[item.id == selectRang[0].id ? 'cellInfo' : 'rangeCellInfo','m-t-4']">
                开始
              </div>
              <div
                  v-else-if="selectRang.length > 0 && item.id == selectRang[selectRang.length-1].id"
                  :class="[item.id == selectRang[selectRang.length-1].id ? 'cellInfo' : 'rangeCellInfo','m-t-4']">
                结束
              </div>
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="bottomView">
        <div :class="[selectRang.length > 1 ? 'bottomBtn': 'disableBtn']" @click.stop="handleConfirm">确定</div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import moment from "moment";

export default {
  props: {
    show: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    type: {
      type: String,
      default: () => {
        return 'month'
      }
    },
    span: {
      type: Number,
      default: () => {
        return 8
      }
    },
    allowSameTime: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  watch: {
    show: {
      handler(val) {
        this.showPopup = val
      },
      immediate: true
    },
    type: {
      handler(val) {
        if (val == 'month') {
          this.list = this.monthData
        } else if (val == 'week') {
          this.list = this.weekData
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      showPopup: false,
      monthData:[],
      weekData:[],
      list: [],
      selectRang: [],
      currentYear: new Date().getFullYear()
    }
  },
  created() {
    this.monthData = this.getAllMonthData()
    // this.weekData = this.getALlWeeksByYear(this.currentYear)
    this.weekData = this.setweekOption(this.currentYear.toString())
    console.log('全年周日历=========')
    console.log(this.weekData)
  },
  mounted() {

  },
  methods: {
    getAllMonthData(){
      let list = Array.from({length: 12}, (value, i) => ({
        id: i + 1,
        title: i + 1,
        start: this.getFirstDayOfMonth(new Date().getFullYear(),(i+1)),
        end: this.getLastDayOfMonth(new Date().getFullYear(),(i+1))
      }))
      console.log('年份日期=====')
      console.log(list)
      return list
    },
    // 查询月份开始结束
    //开始日期
    getFirstDayOfMonth(year, month) {
      // return new Date(year, month-1, 1);
      let data = new Date(year, month - 1, 1);
      return (
        data.getFullYear() +
        "/" +
        (data.getMonth() + 1 > 9
          ? data.getMonth() + 1
          : "0" + (data.getMonth() + 1)) +
        "/" +
        (data.getDate() > 9 ? data.getDate() : "0" + data.getDate())
      );
    },
    //结束日期
    getLastDayOfMonth(year, month) {
      let data = new Date(year, month, 0);
      return (
        data.getFullYear() +
        "/" +
        (data.getMonth() + 1 > 9
          ? data.getMonth() + 1
          : "0" + (data.getMonth() + 1)) +
        "/" +
        (data.getDate() > 9 ? data.getDate() : "0" + data.getDate())
      );
    },

    /**
     * 获取全年有多少周
     * */
    * createWeeks(year) {
      const ONE_DAY = 24 * 3600 * 1000
      let start = new Date(year, 0, 1)
      let end = new Date(year, 11, 31)
      let firstDay = start.getDay() || 7
      let lastDay = end.getDay() || 7
      let startTime = +start
      let endTime = startTime + (7 - firstDay) * ONE_DAY
      let _endTime = end - (7 - lastDay) * ONE_DAY
      yield [startTime, endTime]
      startTime = endTime + ONE_DAY
      endTime = endTime + 7 * ONE_DAY
      while (endTime < _endTime) {
        yield [startTime, endTime]
        startTime = endTime + ONE_DAY
        endTime = endTime + 7 * ONE_DAY
      }
      yield [startTime, +end]
    },
    /**
     * 根据年份获取全年周日历
     * 周算法以
     * 每年的第1个完整周（也就是周一到周天必须在1年内）所在的周，为第1周。
     * 例如：2023年第一个完整周开始日期为2023-01-02，所以第一周为2023/01/02-2023/01/08
     * */
    getALlWeeksByYear(year) {
      let weeks = []
      let index = 1
      console.log(this.createWeeks(year))
      for (let i of this.createWeeks(year)) {
        let start = i[0]
        let end = i[1]
        weeks.push({
          id: index,
          title: `W${this.formatDig(index)}`,
          start: moment(start).format('YYYY/MM/DD'),
          end: moment(end).format('YYYY/MM/DD')
        })
        // console.log(`第${formatDig(index)}周 ${formatDate(start)}-${formatDate(end)}`);
        index++
      }
      return weeks
    },
    setweekOption(year) { //传入年份,字符串类型年份,'2020'
      year = new Date(year).getFullYear()
      let days = this.getDay(year || new Date().getFullYear())
      // console.log(days)
      let weeks = {};
      for (let i = 0; i < days.length; i++) {
        let weeksKeyLen = Object.keys(weeks).length;
        let daySplit = days[i].split('_');
        if (weeks[weeksKeyLen] === undefined) {
          if(daySplit[1] == '1'){
            weeks[weeksKeyLen + 1] = [daySplit[0]]
          }
        } else {
          if (daySplit[1] == '1') {// daySplit[1] == '1' 从周一开始算，周一至周日算一周；daySplit[1] == '0' 从周日开始算，周日至周六算一周
            weeks[weeksKeyLen + 1] = [daySplit[0]]
          } else {
            weeks[weeksKeyLen].push(daySplit[0])
          }
        }
      }
      let option = []
      let weeksKeyLen = Object.keys(weeks).length;
      for (let i = 1; i < weeksKeyLen + 1; i++) {
        let obj = {};
        obj.id = i
        obj.year = year
        obj.title = `W${this.formatDig(i)}`
        obj.md = weeks[i][0] + '-' + weeks[i][weeks[i].length - 1]
        obj.start = `${year}/${weeks[i][0]}`
        obj.end = `${year}/${weeks[i][weeks[i].length - 1]}`

        obj.text = "第" + i + "周" + '(' + weeks[i][0] + '-' + weeks[i][weeks[i].length - 1] + ')';
        obj.value = i;
        option.push(obj)

      }
      return option;
    },
    getDay(year) {
      let dates = [];
      for (let i = 1; i <= 12; i++) {
        for (let j = 1; j <= new Date(year, i, 0).getDate(); j++) {
          dates.push(this.formatNumber(i) + '/' + this.formatNumber(j) + '_' + new Date([year, this.formatNumber(i), this.formatNumber(j)].join('-')).getDay()) //返回当年所有日期（带星期数）
        }
      }
      return dates;
    },
    formatNumber(n) {
      return n.toString().length > 1 ? n : '0' + n
    },
    formatDig(num) {
      return num > 9 ? '' + num : '0' + num
    },
    handleSelect(item) {
      item.start = moment(item.start).format('YYYY/MM/DD')
      item.end = moment(item.end).format('YYYY/MM/DD')
      if (this.allowSameTime) {
        if (this.selectRang.length <= 1) {
          this.selectRang.push(item)
        } else {
          this.selectRang = []
          this.selectRang.push(item)
        }
      } else {
        let index = this.selectRang.findIndex((iItem) => {
          return iItem.id == item.id
        })
        if (this.selectRang.length <= 1) {
          if (index < 0) {
            this.selectRang.push(item)
          }
        } else {
          this.selectRang = []
          this.selectRang.push(item)
        }
      }
      this.selectRang = this.sortKey(this.selectRang,'id')
    },
    sortKey(array,key){
      return array.sort(function(a,b){
        let x = a[key];
        let y = b[key];
        return ((x<y)?-1:(x>y)?1:0)
      })
    },
    onClose() {
      this.selectRang = []
      this.$emit('close')
    },
    handleConfirm() {
      if (this.selectRang.length > 1) {
        console.log('选择时间维度====')
        console.log(this.selectRang)
        let start = `${this.currentYear}/${this.selectRang[0].title}`
        let end = `${this.currentYear}/${this.selectRang[1].title}`
        this.$emit('confirm', this.selectRang, `${start}-${end}`)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("../style/index.css");

.popupView {
  position: relative;
  width: 100%;

  .topView {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 4px 20px rgba(125, 126, 128, 0.16);

    .headerTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      height: 88px;
      font-weight: 500;
      line-height: 88px;
      text-align: center;
    }

    .headerSubTitle {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      height: 88px;
      font-weight: 500;
      line-height: 88px;
      text-align: center;
    }
  }

  .gridList {
    min-height: 484px;
    max-height: 50vh;
    width: 100%;
    padding-bottom: calc(env(safe-area-inset-bottom) + 100px);
    padding-bottom: calc(constant(safe-area-inset-bottom) + 100px);
    overflow-y: scroll;
  }

  .cellInfo {
    font-size: 28px;
    color: #FFFFFF;
  }

  .normalCellInfo {
    font-size: 28px;
    color: #3B3A38;
  }

  .rangeCellInfo {
    color: rgb(25, 137, 250);
    font-size: 28px;
  }

  .normalCell {
    background: #FFFFFF;
    position: relative;
    width: 100%;
    height: 128px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .startCell {
    background: rgb(25, 137, 250);
    position: relative;
    width: 100%;
    height: 128px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .endCell {
    background: rgb(25, 137, 250);
    position: relative;
    width: 100%;
    height: 128px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .startRadius {
    border-radius: 8px 0 0 8px
  }

  .endRadius {
    border-radius: 0 8px 8px 0;
  }

  .rangeCell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 128px;
    background-color: rgba(25, 137, 250, 0.1);
  }

  .bottomView {
    position: fixed;
    background: #FFFFFF;
    bottom: env(safe-area-inset-bottom);
    bottom: constant(safe-area-inset-bottom);
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;

    .bottomBtn {
      width: 90%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #4466F5;
      border-radius: 40px;
      font-size: 28px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
    }

    .disableBtn {
      width: 90%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #4466F5;
      border-radius: 40px;
      font-size: 28px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
      opacity: 0.5;
    }
  }
}

</style>